import React from 'react';
import styled, { css } from 'styled-components';
import { Size } from '../../common/size';
import { Variant } from '../../common/variant';
import { useTestId } from '../../hooks/useTestId';
import { IconNames } from '../Icons/Icon';
import { Text } from '../../Typography/Text/Text';
import { NotificationIcon } from './NotificationIcon';
import { IThemePalette } from '../../Themes/interfaces';
import { CircularIcon } from '../Icons/CircularIcon';

export const notificationColours = (palette: IThemePalette) => ({
  notification: {
    label: {
      text: palette.neutral.white,
      background: palette.primary.first[100]
    },
    // Note: check if other repos are referring to this color
    // Remove if unused
    successIcon: {
      text: palette.neutral.white,
      background: palette.alerts.success,
      border: palette.alerts.success
    },
    // Note: check if other repos are referring to this color
    // Remove if unused
    notificationIcon: {
      text: palette.neutral.white,
      background: palette.alerts.notification,
      border: palette.alerts.notification
    },
    // Note: check if other repos are referring to this color
    // Remove if unused
    alertIcon: {
      text: palette.neutral.white,
      background: palette.alerts.alert,
      border: palette.alerts.alert
    },
    closeIcon: {
      text: palette.neutral.white,
      background: palette.primary.first[75],
      border: palette.primary.text[75]
    }
  }
});

interface INotificationContainerProps {
  showCloseIcon?: boolean;
}

const NotificationContainer = styled.div<INotificationContainerProps>`
  overflow: hidden;
  padding: 0.75rem;
  width: 100%;
  max-width: 33rem;
  min-height: 3.5rem;
  margin: 0.5rem auto;
  vertical-align: middle;
  text-align: center;
  box-sizing: border-box;
  border-radius: 0.25rem;
  ${Text} {
    color: ${({ theme }) => theme.colours.notification.label.text};
  }
  background-color: ${({ theme }) => theme.colours.notification.label.background};
  display: flex;
  gap: 1rem;
  > *:nth-child(2) {
    flex: 1;
  }

  > *:first-child {
    margin-top: 0.25rem;
  }

  //CloseIcon
  & > svg:last-of-type {
    ${(props: INotificationContainerProps) =>
      props.showCloseIcon &&
      css`
        color: ${({ theme }) => theme.colours.notification.closeIcon.text};
        background-color: ${({ theme }) => theme.colours.notification.closeIcon.background};
      `}
  }
`;

export interface INotificationProps {
  variant: Variant;
  onClose?: (e: React.MouseEvent<SVGElement>) => void;
}

export const Notification: React.FC<INotificationProps> = ({ variant, onClose, children, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'Notification');
  return (
    <NotificationContainer showCloseIcon={!!onClose} {...generateTestId()}>
      <NotificationIcon variant={variant} {...generateTestId('NotificationIcon')} />
      {children}
      {onClose && <CircularIcon name={IconNames.X} size={Size.Medium} onClick={onClose} {...generateTestId('CloseIcon')} />}
    </NotificationContainer>
  );
};
